'use strict';
app.factory("signalRService", ['$rootScope', '$http', 'authService', 'cacheService', function ($rootScope, $http, authService, cacheService)
{
    let signalRServiceFactory = {};

    let startKeepAlive = false;

    let _mainSignalR = {
        connection: $.hubConnection($rootScope.httpName + $rootScope.quartoDNS),
        chatHub: null,
        pingInterval: null,
        transport: ['webSockets', 'serverSentEvents', 'longPolling'],
        authData: null,
        isGracefulDisconnect: false,
        isStarting: false,
        startingPoint: null
    };

    let _workflowSignalR = {
        connection: $.hubConnection($rootScope.httpName + $rootScope.workflowDNS),
        chatHub: null,
        pingInterval: null,
        transport: ['webSockets', 'serverSentEvents', 'longPolling'],
        authData: null,
        isGracefulDisconnect: false,
        isStarting: false,
        startingPoint: null
    };

    //define hub proxy
    function _InitializeMainHubProxy()
    {
        try
        {
            //clean up first to stop all previous activity
            if (_mainSignalR.chatHub != null)
            {
                _mainSignalR.chatHub.off('receiveUpdateSignal', null);
                _mainSignalR.chatHub.off('receiveUIUpdateSignal', null);
                _mainSignalR.chatHub.off('getAppVersion', null);
                _mainSignalR.chatHub.off('receiveEvictSignal', null);
                _mainSignalR.chatHub.off('receiveLogoutSignal', null);
                _mainSignalR.chatHub.off('collectJSPerfLog', null);
                _mainSignalR.chatHub.off('onUsageAnalytics', null);
                _mainSignalR.chatHub = null;

                $(_mainSignalR.connection).off("onDisconnect");
                $(_mainSignalR.connection).off("onConnectionSlow");
                $(_mainSignalR.connection).off("onReconnect");

                _mainSignalR.connection.qs = null;
                $.signalR.ajaxDefaults.headers = void 0;
                _mainSignalR.authData = null;
                delete _mainSignalR.connection.proxies.quartochathub;
                _mainSignalR.connection = $.hubConnection($rootScope.httpName + $rootScope.quartoDNS);
            }

            let authData = authService.authentication;
            let token = authData.token;

            if (!token)
            {
                _mainSignalR.authData = null;
                return false;
            }
            else
            {
                _mainSignalR.authData = authData;
                $.signalR.ajaxDefaults.headers = { Authorization: "Bearer " + token };
                _mainSignalR.chatHub = _mainSignalR.connection.createHubProxy('quartoChatHub');
                _mainSignalR.connection.logging = false;
                _mainSignalR.connection.qs = { "token": "Bearer " + token };

                _mainSignalR.chatHub.on('receiveUpdateSignal', (result) => cacheService.Cache.receiveUpdateSignal(typeof result === "string" ? result.split(",") : [""]).then(() =>
                {
                    if (typeof result === "string" && result.includes("clientnotification"))
                        $rootScope.$broadcast('reloadNotification');
                }));

                _mainSignalR.chatHub.on('receiveEvictSignal', (result) => cacheService.Cache.evictCache(result));

                _mainSignalR.chatHub.on('receiveLogoutSignal', () => $rootScope.$emit("SignalRLogout", {}));

                _mainSignalR.chatHub.on('collectJSPerfLog', () => cacheService.Logging.postPerfDBLog());

                _mainSignalR.chatHub.on('getAppVersion', (version) => _onAppVersion(version, "ChatHub"));

                _mainSignalR.chatHub.on('receiveUIUpdateSignal', (UserKeys) =>
                {
                    if (Array.isArray(UserKeys) && UserKeys.length > 0)
                    {
                        if (UserKeys.findIndex((item) => (+item) === _mainSignalR.authData.userKey) != -1)
                        {
                            $rootScope.$broadcast("receiveUIUpdateSignal", true);
                        }
                    }
                });

                _mainSignalR.chatHub.on('onUsageAnalytics', (data) => $rootScope.$broadcast("onUsageAnalytics", data));

                _mainSignalR.connection.disconnected(() =>
                {
                    if (_mainSignalR.isGracefulDisconnect)
                    {
                        //stopped gracefully, ignore
                    }
                    else
                    {
                        //check if there is internet connection
                        if (window.navigator.onLine)
                        {
                            _startMainSignalR();
                        }
                        else
                        {
                            if (!window.ononline)
                                window.ononline = () => _startMainSignalR();
                        }
                    }
                });

                _mainSignalR.connection.connectionSlow(() => console.info("slow signalR connection detected."));

                _mainSignalR.connection.reconnected(() =>
                {
                    window.ononline = null;
                    _mainSignalR.chatHub.invoke('startChat', authData.token).then(() =>
                    {
                        D(() => console.info("on chatHub startChat (reconnected)"));
                        _checkAppVersion();
                        cacheService.Cache.evictOutdatedCache().then(() => $rootScope.$broadcast("onChatHubReconnected"), () => $rootScope.$broadcast("onChatHubReconnected"));
                    }, () => _startMainSignalR());
                });

                return true;
            }
        }
        catch (err)
        {
            console.error("InitializeMainHubProxy", err);
            return false;
        }
    }

    function _InitializeWorkflowHubProxy()
    {
        try
        {
            //clean up first to stop all previous activity
            if (_workflowSignalR.chatHub != null)
            {
                _workflowSignalR.chatHub = null;

                $(_workflowSignalR.connection).off("onDisconnect");
                $(_workflowSignalR.connection).off("onConnectionSlow");
                $(_workflowSignalR.connection).off("onReconnect");

                _workflowSignalR.connection.qs = null;
                _workflowSignalR.authData = null;
                delete _workflowSignalR.connection.proxies.workflowchathub;
                _workflowSignalR.connection = $.hubConnection($rootScope.httpName + $rootScope.workflowDNS);
            }

            let authData = authService.authentication;
            let token = authData.token;

            if (!token)
            {
                _workflowSignalR.authData = null;
                return false;
            }
            else
            {
                _workflowSignalR.authData = authData;
                _workflowSignalR.chatHub = _workflowSignalR.connection.createHubProxy('workflowChatHub');
                _workflowSignalR.connection.logging = false;
                _workflowSignalR.connection.qs = { "token": "Bearer " + token };
                return true;
            }
        }
        catch (err)
        {
            console.error("InitializeWorkflowHubProxy", err);
            return false;
        }
    }

    let _startMainSignalR = function ()
    {
        if (_mainSignalR.isStarting)
        {
            return _mainSignalR.startingPoint;
        }
        else
        {
            _mainSignalR.isStarting = true;
            _mainSignalR.startingPoint = new Promise((resolve, reject) =>
            {
                try
                {
                    _stopMainSignalR(true).then(() =>
                    {
                        if (_InitializeMainHubProxy())
                        {
                            _mainSignalR.connection.start({ pingInterval: _mainSignalR.pingInterval, transport: _mainSignalR.transport, waitForPageLoad: false }).done(() =>
                            {
                                $rootScope.notificationReady = true;

                                //Join & Get Notification
                                _mainSignalR.chatHub.invoke('startChat', _mainSignalR.authData.token).then(() =>
                                {
                                    D(() => console.info("on chatHub startChat"));
                                    _mainSignalR.isGracefulDisconnect = false;
                                    _checkAppVersion();
                                    window.ononline = null;

                                    //remove outdated cache
                                    cacheService.Cache.evictOutdatedCache().then(() =>
                                    {
                                        _mainSignalR.isStarting = false;
                                        resolve();
                                    }, () =>
                                    {
                                        _mainSignalR.isStarting = false;
                                        resolve();
                                    });
                                }, (err) =>
                                {
                                    try
                                    {
                                        _mainSignalR.isGracefulDisconnect = true;

                                        if (_mainSignalR.connection.state !== $.signalR.connectionState.disconnected)
                                        {
                                            _mainSignalR.connection.stop(false, true);
                                            console.log("%cSignalR stopped!", 'background:blue;color:#fff');
                                        }
                                    }
                                    catch { }

                                    console.error("StartMainSignalR StartChat", err);
                                    _mainSignalR.isStarting = false;
                                    reject();
                                });
                            }).fail((err) =>
                            {
                                console.error("StartMainSignalR", err);
                                _mainSignalR.isStarting = false;
                                reject();
                            });
                        }
                        else
                        {
                            _mainSignalR.isStarting = false;
                            reject();
                        }
                    }, () =>
                    {
                        _mainSignalR.isStarting = false;
                        reject();
                    });
                }
                catch (err)
                {
                    console.error("StartMainSignalR", err);
                    _mainSignalR.isStarting = false;
                    reject();
                }
            });

            return _mainSignalR.startingPoint;
        }
    }

    let _startSignalR = function (type)
    {
        if (type === "workflow")
        {
            if (_workflowSignalR.isStarting)
            {
                return _workflowSignalR.startingPoint;
            }
            else
            {
                _workflowSignalR.isStarting = true;
                _workflowSignalR.startingPoint = new Promise((resolve, reject) =>
                {
                    try
                    {
                        _stopSignalR(type).then(() =>
                        {
                            if (_InitializeWorkflowHubProxy())
                            {
                                _workflowSignalR.connection.start({ pingInterval: _workflowSignalR.pingInterval, transport: _workflowSignalR.transport, waitForPageLoad: false }).done(() =>
                                {
                                    _workflowSignalR.isGracefulDisconnect = false;
                                    _workflowSignalR.isStarting = false;
                                    resolve();
                                }).fail((err) =>
                                {
                                    console.error("StartWorkflowSignalR", err);
                                    _workflowSignalR.isStarting = false;
                                    reject();
                                });
                            }
                            else
                            {
                                _workflowSignalR.isStarting = false;
                                reject();
                            }
                        }, () =>
                        {
                            _workflowSignalR.isStarting = false;
                            reject();
                        });
                    }
                    catch (err)
                    {
                        console.error("StartWorkflowSignalR", err);
                        _workflowSignalR.isStarting = false;
                        reject();
                    }
                });

                return _workflowSignalR.startingPoint;
            }
        }
        else if (type === "main")
        {
            return _startMainSignalR();
        }
        else
        {
            return Promise.reject();
        }
    }

    let _stopMainSignalR = function ()
    {
        return new Promise((resolve, reject) =>
        {
            try
            {
                _mainSignalR.isGracefulDisconnect = true;

                if (_mainSignalR.connection.state !== $.signalR.connectionState.disconnected)
                {
                    _mainSignalR.connection.stop(false, true);
                    console.log("%cSignalR stopped!", 'background:blue;color:#fff');
                }

                resolve();
            }
            catch (err)
            {
                console.error("StopMainSignalR", err);
                reject();
            }
        });
    }

    let _stopSignalR = function (type)
    {
        return new Promise((resolve, reject) =>
        {
            try
            {
                if (type === "workflow")
                {
                    _workflowSignalR.isGracefulDisconnect = true;

                    if (_workflowSignalR.connection.state !== $.signalR.connectionState.disconnected)
                    {
                        _workflowSignalR.connection.stop(false, true);
                    }

                    resolve();
                }
                else if (type === "main")
                {
                    _stopMainSignalR().then(() => resolve(), () => reject());
                }
                else
                {
                    reject();
                }
            }
            catch (err)
            {
                console.error("StopSignalR", err);
                reject();
            }
        });
    }

    /**
     * @param {string} version
     * @param {string} source - for debugging purpose, to know where the version is coming from    */
    let _onAppVersion = function (version, source = "unknown")
    {
        if (_.isNil(version))
        {
            D(() => console.info("on ChatHubAppVersion, source:", source,
                "server:", version,
                "local:", $rootScope.chatHubAppVersion,
                "action:", "nothing"));

            //no response from server, do nothing
        }
        else if (_.isNil($rootScope.chatHubAppVersion))
        {
            D(() => console.info("on ChatHubAppVersion, source:", source,
                "server:", version,
                "local:", $rootScope.chatHubAppVersion,
                "action:", "assign version"));

            //local do not have version, assign from server
            $rootScope.chatHubAppVersion = version;
        }
        else if ($rootScope.chatHubAppVersion !== version)
        {
            D(() => console.info("on ChatHubAppVersion, source:", source,
                "server:", version,
                "local:", $rootScope.chatHubAppVersion,
                "action:", "prompt refresh"));

            //local have version, but different from server, prompt refresh (delay 5s as workaround to allow mainController to load first)
            setTimeout(() => $rootScope.$broadcast("openWinVersion", true), 5000);
        }
    }

    let _checkAppVersion = function ()
    {
        try
        {
            if (_mainSignalR.connection.state === $.signalR.connectionState.connected)
            {
                // Use signalR to check for ChatHub app version is more resource friendly.
                _mainSignalR.chatHub.invoke('getAppVersion');
            }
            else
            {
                // Fallback to HTTP GET to check for ChatHub app version.
                (async () =>
                {
                    try
                    {
                        const appVersionApi = $rootScope.quartoWebApiurl + "ChatHubAppVersion/Get";
                        const version = (await (await fetch(appVersionApi)).json()).Version;
                        _onAppVersion(version, "HttpGet");
                    }
                    catch (err)
                    {
                        console.error("httpGet ChatHubAppVersion", err);
                    }
                })();
            }
        }
        catch (ex)
        {
            console.error(ex);
        }
    };

    let _getUsageAnalytics = function ()
    {
        ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
            ? Promise.resolve()
            : _startMainSignalR()
        ).then(() =>
        {
            _mainSignalR.chatHub.invoke('getUsageAnalytics').then((data) =>
            {
                $rootScope.$broadcast("onUsageAnalytics", data)
            });
        });
    }

    let _postUsageAnalytics = function (menuTableName, menuKey)
    {
        return new Promise((resolve, reject) =>
        {
            if (_.isEmpty(menuTableName) || !_.isNumber(menuKey))
            {
                resolve();
            }

            ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
                ? Promise.resolve()
                : _startMainSignalR()
            ).then(() =>
            {
                _mainSignalR.chatHub.invoke('postUsageAnalytics', menuTableName, menuKey).then(() => resolve(), () => reject());
            }, () => reject());
        });
    }

    let _postReportExecution = function (sessionID, RenderingStart, FirstPageLoad, RenderingEnd, PageCount)
    {
        return new Promise((resolve, reject) =>
        {
            ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
                ? Promise.resolve()
                : _startMainSignalR()
            ).then(() =>
            {
                _mainSignalR.chatHub.invoke('postReportExecutionInformation', sessionID, RenderingStart, FirstPageLoad, RenderingEnd, PageCount).then(() => resolve(), () => reject());
            }, () => reject());
        });
    }

    let _postFormUsage = function (formName, MenuKey)
    {
        try
        {
            let authData = authService.authentication;
            if (!!authData.token)
            {
                ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
                    ? Promise.resolve()
                    : _startMainSignalR()
                ).then(() =>
                {
                    _mainSignalR.chatHub.invoke('postFormUsage', formName.toString(), MenuKey.toString(), authData.clientID.toString(), authData.userKey.toString());
                });
            }
        }
        catch (err) { }
    };

    let _postScreenSize = function ()
    {
        //selectively sample
        if (Math.floor(Math.random() * 2) == 0 || Math.floor(Math.random() * 2) == 0)
        {
            return;
        }

        try
        {
            let authData = authService.authentication;
            if (!!authData.token && !!window && !!window.screen)
            {
                ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
                    ? Promise.resolve()
                    : _startMainSignalR()
                ).then(() =>
                {
                    _mainSignalR.chatHub.invoke('postScreenSize', window.screen.height.toString(), window.screen.width.toString(), authData.clientID.toString(), authData.userKey.toString());
                });
            }
        }
        catch (err) { }
    };

    let _postNetSpeed = function ()
    {
        //selectively sample
        if (Math.floor(Math.random() * 2) == 0 || Math.floor(Math.random() * 2) == 0)
        {
            return;
        }

        try
        {
            let authData = authService.authentication;
            if (!!authData.token && !!window && !!window.screen)
            {
                ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
                    ? Promise.resolve()
                    : _startMainSignalR()
                ).then(() =>
                {
                    setTimeout(() =>
                    {
                        //latency test
                        let startTime = performance.now();
                        $http.get("/connection-test", { timeout: 60000 }).then(() =>
                        {
                            let elapsedms_latency = (performance.now() - startTime);

                            //load test
                            startTime = performance.now();
                            $http.get($rootScope.httpName + $rootScope.quartoDNS + "/api/SpeedTest/GetPayload", { timeout: 60000 }).then(() =>
                            {
                                let elapsedms_load = (performance.now() - startTime);
                                if (elapsedms_latency > 0 && elapsedms_load > 0 && elapsedms_load >= elapsedms_latency)
                                {
                                    D(() => console.log("Communication Test to Quarto API: Response round trip took " + elapsedms_latency.toString() + " ms"));
                                    D(() => console.log("Communication Test to Quarto API: 5MB package retrieval took " + elapsedms_load.toString() + " ms (Estimate: " + ((5000000 / (elapsedms_load / 1000)) / 125000).NtoDP(4).toString() + " Mbps)"));

                                    _mainSignalR.chatHub.invoke('postNetSpeed', ((5000000 / (elapsedms_load / 1000)) / 125000).NtoDP(4).toString(), elapsedms_latency.NtoDP(4).toString(), authData.clientID.toString(), authData.userKey.toString());
                                }
                            });
                        });
                    }, 60000);
                });
            }
        }
        catch (err) { }
    };

    let _getWorkFlowProgressMessage = function (processID)
    {
        return new Promise((resolve, reject) =>
        {
            ((_workflowSignalR.connection.state === $.signalR.connectionState.disconnected) ? _startSignalR("workflow")
                : (_workflowSignalR.connection.state === $.signalR.connectionState.connected) ? Promise.resolve()
                    : Promise.reject()).then(() =>
                    {
                        _workflowSignalR.chatHub.invoke('getMsg', processID).then((data) =>
                        {
                            if (data.startsWith("service_"))
                            {
                                try
                                {
                                    //in case null causing parse fails
                                    resolve({
                                        type: "service",
                                        rawData: angular.copy(JSON.parse(data.substr(8)))
                                    });
                                }
                                catch (ex)
                                {
                                    reject();
                                }
                            }
                            else if (data.startsWith("progress_"))
                            {
                                resolve({
                                    type: "progress",
                                    rawData: angular.copy(data.substr(9))
                                });
                            }
                            else
                            {
                                //no messages yet
                                resolve({
                                    type: "blank",
                                    rawData: {}
                                });
                            }
                        });
                    }, () => reject());
        });
    };

    let _getProgressMessage = function (processID, type)
    {
        return new Promise((resolve, reject) =>
        {
            ((_mainSignalR.connection.state === $.signalR.connectionState.disconnected) ? _startSignalR("main")
                : (_mainSignalR.connection.state === $.signalR.connectionState.connected) ? Promise.resolve()
                    : Promise.reject()).then(() =>
                    {
                        if ((typeof type === "string") && type == "copyBudget")
                        {
                            _mainSignalR.chatHub.invoke('getBgtCopyProgressMsg', processID).then((data) =>
                            {
                                if (data.startsWith("completed"))
                                {
                                    resolve({
                                        type: "service",
                                        rawData: data
                                    });
                                }
                                else
                                {
                                    reject();
                                }
                            });
                        }
                        else if ((typeof type === "string") && type == "importData")
                        {
                            _mainSignalR.chatHub.invoke('getImportDataProgressMsg', processID).then((data) =>
                            {
                                if (data.startsWith("completed"))
                                {
                                    resolve({
                                        type: "service",
                                        rawData: data
                                    });
                                }
                                else
                                {
                                    reject();
                                }
                            });
                        }
                        else
                        {
                            reject();
                        }
                    }, () => reject());
        });
    };

    let _checkAlive = function ()
    {
        const EXCEPTION_COULD_NOT_FIND_TOKEN = "Could not find matching token.";

        return new Promise((resolve, reject) =>
        {
            try
            {
                if (typeof authService?.authentication?.token !== "string")
                {
                    reject(EXCEPTION_COULD_NOT_FIND_TOKEN);
                }
                else
                {
                    ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
                        ? new Promise((_resolve, _reject) =>
                        {
                            _mainSignalR.chatHub.invoke('checkAlive', authService.authentication.token).then((isAlive) =>
                            {
                                if (isAlive === true)
                                    _resolve();
                                else
                                    _reject();
                            }, () => _reject());
                        })
                        : Promise.reject()
                    ).then(() => resolve(), () =>
                    {
                        $http.get($rootScope.httpName + $rootScope.quartoDNS + "/api/UserAccess/CheckAlive?token=" + authService.authentication.token, { timeout: 60000 }).success((response) =>
                        {
                            try
                            {
                                if (JSON.parse(response) === true)
                                {
                                    resolve();
                                }
                                else
                                {
                                    reject(EXCEPTION_COULD_NOT_FIND_TOKEN);
                                }
                            }
                            catch (err)
                            {
                                console.error("CheckAlive", err);
                                reject(EXCEPTION_COULD_NOT_FIND_TOKEN);
                            }
                        }).error((err, status) =>
                        {
                            console.error("CheckAlive", err);
                            reject(EXCEPTION_COULD_NOT_FIND_TOKEN);
                        });
                    });
                }
            }
            catch (err)
            {
                console.error("CheckAlive", err);
                reject(EXCEPTION_COULD_NOT_FIND_TOKEN);
            }
        });
    }

    function random()
    {
        //ideally should be 180000
        let min = 170000;
        let max = 200000;

        return (min + Math.random() * (max - min)).NtoDP(0);
    };

    function randomTick()
    {
        if (startKeepAlive)
        {
            setTimeout(() =>
            {
                if (startKeepAlive)
                {
                    _checkAlive().then(() => randomTick(), () => randomTick());
                }
            }, random());
        }
    };

    let _keepAlive = function (isStart)
    {
        try
        {
            if (isStart === true && startKeepAlive === true)
            {
                //do nothing, already started
            }
            else
            {
                startKeepAlive = isStart;
                randomTick();
            }
        }
        catch (ex) { }
    };

    let _refreshSession = function ()
    {
        return new Promise((resolve, reject) =>
        {
            _keepAlive(false);
            _checkAlive().then(() =>
            {
                _startMainSignalR().then(() => Promise.resolve(), () => Promise.resolve()).then(() =>
                {
                    _keepAlive(true);
                    resolve();
                    _postScreenSize();
                    _postNetSpeed();
                });
            }, () => reject());
        });
    };

    let _broadcastUIUpdateSignal = function (UserGrpKeys)
    {
        return new Promise((resolve, reject) =>
        {
            if (typeof UserGrpKeys !== "undefined" && Array.isArray(UserGrpKeys) && UserGrpKeys.length > 0)
            {
                ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
                    ? Promise.resolve()
                    : _startMainSignalR()
                ).then(() =>
                {
                    _mainSignalR.chatHub.invoke('broadcastUIUpdateSignal', UserGrpKeys).then(() => resolve(), () => reject());
                }, () => reject());
            }
            else
            {
                reject();
            }
        });
    }

    signalRServiceFactory.startSignalR = _startSignalR;
    signalRServiceFactory.startMainSignalR = _startMainSignalR;

    signalRServiceFactory.stopMainSignalR = _stopMainSignalR;
    signalRServiceFactory.stopSignalR = _stopSignalR;

    signalRServiceFactory.getUsageAnalytics = _getUsageAnalytics;
    signalRServiceFactory.postUsageAnalytics = _postUsageAnalytics;
    signalRServiceFactory.postFormUsage = _postFormUsage;
    signalRServiceFactory.postReportExecution = _postReportExecution;
    signalRServiceFactory.postScreenSize = _postScreenSize;
    signalRServiceFactory.postNetSpeed = _postNetSpeed;

    signalRServiceFactory.getWorkFlowProgressSessionID = () => (cacheService.Utility.generateRandomID() + cacheService.Utility.generateRandomID() + '-' + cacheService.Utility.generateRandomID() + '-' + cacheService.Utility.generateRandomID() + '-' + cacheService.Utility.generateRandomID() + '-' + cacheService.Utility.generateRandomID() + '_' + (authService.authentication.clientID ?? ""));
    signalRServiceFactory.getWorkFlowProgressMessage = _getWorkFlowProgressMessage;
    signalRServiceFactory.getProgressMessage = _getProgressMessage;

    signalRServiceFactory.checkAlive = _checkAlive;
    signalRServiceFactory.keepAlive = _keepAlive;
    signalRServiceFactory.checkAppVersion = _checkAppVersion;

    signalRServiceFactory.refreshSession = _refreshSession;
    signalRServiceFactory.broadcastUIUpdateSignal = _broadcastUIUpdateSignal;

    $rootScope.getConnectionState = function (type)
    {
        try
        {
            if (type === "workflow")
            {
                return _workflowSignalR.connection.state;
            }
            else if (type === "main")
            {
                return _mainSignalR.connection.state;
            }
            else
            {
                return $.signalR.connectionState.disconnected;
            }
        }
        catch (err)
        {
            return $.signalR.connectionState.disconnected;
        }
    };

    $rootScope.broadcastEvictSignal = function (type, target)
    {
        ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
            ? Promise.resolve()
            : _startMainSignalR()
        ).then(() =>
        {
            _mainSignalR.chatHub.invoke('broadcastEvictSignal', type, target);
        });
    }

    $rootScope.broadcastLogoutSignal = function (target)
    {
        ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
            ? Promise.resolve()
            : _startMainSignalR()
        ).then(() =>
        {
            _mainSignalR.chatHub.invoke('broadcastLogoutSignal', target);
        });
    }

    $rootScope.postPerfDBLog = function (content)
    {
        ((_mainSignalR.connection.state === $.signalR.connectionState.connected)
            ? Promise.resolve()
            : _startMainSignalR()
        ).then(() =>
        {
            _mainSignalR.chatHub.invoke('postPerfDBLog', content);
        });
    }

    $rootScope.propagateSignal = function (type)
    {
        return new Promise((resolve, reject) =>
        {
            (_mainSignalR.connection.state === $.signalR.connectionState.connected
                ? Promise.resolve()
                : _startMainSignalR()
            ).then(
                () => _mainSignalR.chatHub.invoke('broadcastUpdateSignal', type).then((result) => resolve(result), () => reject()),
                () => reject()
            );
        });
    }

    $rootScope.getAttachmentCount = function (RefKey, RefSubject)
    {
        return new Promise(function (resolve, reject)
        {
            if ((typeof RefKey == "number" || typeof RefKey == "string") && typeof RefSubject == "string")
            {
                let _refKey = +RefKey;
                let _refSubject = RefSubject.trim().toUpperCase();

                if (_refSubject == "")
                {
                    resolve(0);
                }

                (_mainSignalR.connection.state === $.signalR.connectionState.connected
                    ? Promise.resolve()
                    : _startMainSignalR()
                ).then(() =>
                {
                    _mainSignalR.chatHub.invoke('getAttachmentCount', _refKey, _refSubject).then((result) => resolve(result), () => resolve(0));
                }, () => resolve(0));
            }
            else
            {
                resolve(0);
            }
        });
    }

    //type 0-whatsnew, 1-notification || action 0-read, 1-delete, 2-update_IsRead_column
    $rootScope.updateNotificationStats = function (type, action, isAdmin = false, key = -1)
    {
        return new Promise((resolve, reject) =>
        {
            (_mainSignalR.connection.state === $.signalR.connectionState.connected
                ? Promise.resolve()
                : _startMainSignalR()
            ).then(() =>
            {
                _mainSignalR.chatHub.invoke('updateNotificationStats', type, action, isAdmin, key).then((result) => resolve(result), () => reject());
            });
        });
    }

    $rootScope.invokeJSPerfLogCollection = function ()
    {
        return new Promise((resolve, reject) =>
        {
            (_mainSignalR.connection.state === $.signalR.connectionState.connected
                ? Promise.resolve()
                : _startMainSignalR()
            ).then(() =>
            {
                _mainSignalR.chatHub.invoke('invokeJSPerfLogCollection').then((result) => resolve(result), (err) => reject(err));
            });
        });
    }

    return signalRServiceFactory;
}]);